<div class="d-flex justify-content-end" style="align-items: center">
  <div class="d-flex flex-wrap">
    @for (indicator of indicators; track indicator; let i = $index) {
    <span class="button-indicator"
      [style.background-color]="i === currentExerciseNumber() - 1 ? clozeTestStyleModel().specialCharacterListColor : clozeTestStyleModel().specialCharacterListDisabledColor"
      [style.color]="i === currentExerciseNumber() - 1 ? 'white' : ''">
      {{ indicator }}
    </span>
    }
  </div>
</div>